import React, { Fragment } from 'react'
import { Portal } from 'react-portal'
import Tooltip from 'react-tooltip'
import { useMedia } from 'sb-hooks'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import s from './HelpIconWithTooltip.scss'


type HelpIconWithTooltipProps = {
  className?: string
  message: ReactIntlMessage
  id: number
}

const mobileToolipProps = {
  place: 'bottom',
  event: 'click',
  globalEventOff: 'click',
  multiline: true,
}

const HelpIconWithTooltip: React.FunctionComponent<HelpIconWithTooltipProps> = (props) => {
  const { className, message, id } = props

  const { isMobile }      = useMedia()
  const buttonClassName   = cx(className, s.helpButton)

  return (
    <Fragment>
      <button
        className={buttonClassName}
        type="button"
        data-tip
        data-for={id}
        aria-labelledby={id}
      />
      <Portal>
        <Tooltip
          id={id}
          className={s.note}
          place="right"
          type="light"
          effect="solid"
          border
          {...(isMobile ? mobileToolipProps : {})}
        >
          <Message text={message} html />
        </Tooltip>
      </Portal>
    </Fragment>
  )
}


export default React.memo(HelpIconWithTooltip)
